import axios from '@/axios'

export default {
  entriesForEvent(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/event-entries/event/${ id }`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  markAsPaid(id) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/event-entries/paid/${ id }`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  verifyPop(id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-entries/update-verify-pop/${ id }`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  sendPaymentRequest(id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-entries/send-payment-request/${ id }`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  updateTeamName(entry) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-entries/update-team-name/${ entry._id }`, {
          teamname: entry.teamname
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  updateGymname(entry) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-entries/update-gymname/${ entry._id }`, {
          gymname: entry.gymname
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  updateCategory(entry) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-entries/update-category/${ entry._id }`, {
          category: entry.category
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  deleteEntry(entry) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/event-entries/${ entry._id }`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  export(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`event-entries/export/${ id }`)
        .then(() => {
          window.location =
            axios.defaults.baseURL +
            '/admin/download-export/event-entries-' +
            id
          resolve()
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
